interface ProgressPipsProps {
  total: number;
  current: number;
  completed: boolean[];
}

export function ProgressPips({ total, current, completed }: ProgressPipsProps) {
  return (
    <div className="escape-pips" role="list" aria-label="Room progress">
      {Array.from({ length: total }, (_, i) => {
        const isDone = completed[i];
        const isCurrent = i === current && !isDone;

        let ariaLabel = `Room ${i + 1}`;
        if (isDone) ariaLabel += ' — completed';
        else if (isCurrent) ariaLabel += ' — current';
        else ariaLabel += ' — not yet reached';

        return (
          <span
            key={i}
            role="listitem"
            aria-label={ariaLabel}
            className={[
              'escape-pip',
              isDone    ? 'escape-pip--done'    : '',
              isCurrent ? 'escape-pip--current' : '',
            ]
              .filter(Boolean)
              .join(' ')}
          />
        );
      })}
    </div>
  );
}
